import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { roadsideQueryKeys } from "./queryKeys"
import { useRoadsideQuery } from "./useRoadsideQuery"

export function useRoadsideInventoryTypesStats(parameters = {}, config = {}) {

    const url = "homogeneous_roadside_inventories/stats/inventory_types/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    })

    const queryKey = roadsideQueryKeys["stats_inventory_types"](queryParameters)

    return useRoadsideQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}